import { IZone, IFacility } from '../custom/classes/production';
import { IPackageListingAppState } from '../redux-state';
import { flatMap } from 'lodash';
import { filterMap, filterMapByValue } from './map-helpers';

export interface ICartItemDetail {
    facility: IFacility;
    itemTitle: string;
    itemDate: string;
    itemTime: string;
    itemIdToRemove: number;
}

export function getCartItemDetails(state: IPackageListingAppState, itemId: number): ICartItemDetail {
    let itemDetail: ICartItemDetail = null;

    if (state.packageListingSettings.isFixed) {
        const matchedFixed = state.packageListing.packages.filter(p => p.id == itemId);

        if (matchedFixed.length === 1) {
            itemDetail = {
                facility: matchedFixed[0].facility,
                itemDate: "",
                itemTime: "",
                itemTitle: matchedFixed[0].title,
                itemIdToRemove: itemId
            };
        } else {
            const allSubPackages = flatMap(state.packageListing.packages
                .map(pkg => pkg.subPackages));

            const matchedSubPackage = allSubPackages.filter(p => p.id == itemId)[0];

            if (matchedSubPackage) {
                var packageId = filterMapByValue(state.packageListing.subPackagesInCart,
                    value => {
                        return value.indexOf(matchedSubPackage.id) >= 0
                    }).keys().next().value;

                if (packageId) {
                    const subPackages = state.packageListing.subPackagesInCart.get(packageId);
                    itemDetail = {
                        facility: matchedSubPackage.facility,
                        itemDate: "",
                        itemTime: "",
                        itemIdToRemove: packageId,
                        itemTitle: subPackages.indexOf(matchedSubPackage.id) === 0 ?
                            state.packageListing.packages.filter(p => p.id === packageId)[0].title
                            : ""
                    };
                }

            }

        }
    } else {
        const allPerf = flatMap(state.packageListing.packageDetail.performanceGroupDetails
            .map(group => flatMap(group.appProductions.map(prod => prod.performances))));

        const matchedPerf = allPerf.filter(p => p.performanceId == itemId)[0];

        if (matchedPerf) {
            itemDetail = {
                facility: matchedPerf.facility,
                itemDate: matchedPerf.performanceDateDayString,
                itemTime: matchedPerf.performanceTimeString,
                itemTitle: matchedPerf.title,
                itemIdToRemove: itemId
            };

        }
    }

    return itemDetail;
}


